<template>
  <div class="left-panel">
    <div class="header">
      <div class="title">
        Steps Completed ({{ stepsCompleted }} of {{ stepsTotal }})
      </div>
    </div>

    <TaskSection
      title="Task Definition"
      :steps-list="stepsList"
      :steps-time="stepsTime"
      :substep-metrics="substepMetrics"
    />
  </div>
</template>

<script>
import TaskSection from './TaskSection.vue';

export default {
  name: 'LeftPanel',
  components: { TaskSection },
  props: {
    stepsList: { type: Array, default: () => [] },
    stepsCompleted: { type: Number, default: 0 },
    stepsTotal: { type: Number, default: 0 },
    stepsTime: { type: Object, default: () => ({}) },
    substepMetrics: { type: Object, default: () => ({}) },
  },
};
</script>

<style scoped>
.left-panel {
  background: #f7f7fb;
  border-radius: var(--radius);
  /* Remove right padding so inner blocks reach the column edge */
  padding: var(--card-pad);
  display: flex;
  flex-direction: column;
  gap: var(--gap);
  min-height: 0;
  height: 100%;
  width: 100%;
  /* Avoid extra inner gutter appearance from outer border */
  border: none;
}

/* Make inner blocks span the full available width */
.left-panel .header,
.left-panel :deep(.task-section) {
  width: 100%;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--gap);
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: var(--radius);
  padding: 10px 12px;
  margin-right: var(--gap); /* visually align with middle column gutter */
}

.title {
  font-weight: 700;
  font-size: var(--fs-h);
  color: #1f2937;
}

.icon {
  width: 36px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #fff;
  display: grid;
  place-content: center;
  gap: 3px;
}
.icon .bar {
  width: 18px;
  height: 2px;
  background: #111827;
  display: block;
}
.icon:hover {
  background: #f3f4f6;
}

@media (max-width: 780px) {
  .left-panel {
    padding: calc(var(--card-pad) - 4px);
  }
  .header {
    padding: 8px 10px;
    margin-right: 0; /* no extra gutter on single-column layout */
  }
  .title {
    font-size: clamp(16px, 4.5vw, 20px);
  }
}
</style>
